import { LocationType, SupportedTradingPartner } from "@deliverr/freight-client";
import { QuoteLocationTypes } from "freight/types/QuoteLocationTypes";

export const getLocationType = (locationOption: QuoteLocationTypes | null): LocationType | null =>
  locationOption === SupportedTradingPartner.FULFILLMENT_BY_AMAZON ? LocationType.COMMERCIAL : locationOption;
